var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:{loader_hover: _vm.hover}},[_c('img',{style:({width: _vm.pxSize, height: _vm.pxSize}),attrs:{"src":"/uikit/svg/icons/loader.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }